import styled from '@emotion/styled';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import { breakpoints } from '@styles/index';

const Wrapper = styled.div`
  grid-column: span 18;
  margin: 10% auto;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    grid-column: span 10;
  }
`;

const Loader = () => {
  return (
    <Wrapper>
      <CircularLoader color="var(--color-i-green)" />
    </Wrapper>
  );
};

export default Loader;
